import { render } from "./RectangleButton.vue?vue&type=template&id=66bedd9b"
import script from "./RectangleButton.vue?vue&type=script&lang=js"
export * from "./RectangleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__